<template>
  <div class="flex w-full">
    <div v-if="shouldDisplayDisclaimer" class="text-base-md !text-m richtext text-racq-med-grey mb-13">
      <!-- Display default disclaimer if no step disclaimers are available -->
      <template v-if="fields?.defaultDisclaimer">
        <RichText :field="{ value: fields?.defaultDisclaimer || '&nbsp;' }" />
      </template>

      <!-- Display disclaimers from the store if they exist -->
      <template v-if="stepDisclaimers.length">
        <div class="mt-4 text-base-md">
          <p v-if="!fields?.defaultDisclaimer" class="text-lg mb-4 !font-medium font-sans leading-7">
            {{ dictionary.DisclaimerHeading }}
          </p>
          <template v-for="(disclaimer, key) in stepDisclaimers" :key="key">
            <RichText class="text-base !text-m text-racq-med-grey" :field="{ value: disclaimer || '&nbsp;' }" tag="p" />
          </template>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useFormStepDisclaimerStore } from '@/store';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

// Define props and emitters
// ------------------------------------------------------------- //
const props = defineProps<{
  fields: {
    stepTitle?: string;
    defaultDisclaimer?: string;
  };
  testParams?: {
    mockDisclaimerHeading: string;
    mockFormStepDisclaimerStoreResponse: string[];
  };
}>();

// Define component state
// ------------------------------------------------------------- //
const translation = useI18n();
const dictionary: Record<string, string> = translation.getLocaleMessage('en') as any;
const formStepDisclaimerStore = useFormStepDisclaimerStore();

if (props.testParams) {
  formStepDisclaimerStore.additionalDisclaimer.length = props.testParams.mockFormStepDisclaimerStoreResponse.length;

  dictionary.DisclaimerHeading = props.testParams.mockDisclaimerHeading;
}
// Computed properties
// ------------------------------------------------------------- //
const stepDisclaimers = computed(() => {
  let disclaimers = formStepDisclaimerStore.getDisclaimersForStep(props.fields.stepTitle);

  if (props.testParams) {
    disclaimers = props.testParams.mockFormStepDisclaimerStoreResponse;
  }
  return disclaimers;
});

// Computed property to determine if the disclaimer should be shown
const shouldDisplayDisclaimer = computed(() => {
  return props.fields?.defaultDisclaimer || formStepDisclaimerStore?.additionalDisclaimer?.length;
});
</script>
